import { ProductType } from '@inter-ikea-storageone/range';
import { removeProductsAndUpdateInnerLights } from '../utils/removeProducts';
import { BehaviorParameters } from 'rangeConfig/@types';

const removeAllSlidingDoorsFromScene = ({ coreApi }: BehaviorParameters) => {
  const slidingDoors = coreApi.entities.getByProductTypes([
    ProductType.PAX_SLIDING_DOOR_REGULAR_ASM,
    ProductType.PAX_SLIDING_DOOR_WITH_PANELS_ASM
  ]);

  if (slidingDoors.length > 0) {
    removeProductsAndUpdateInnerLights(slidingDoors, coreApi);
  }
};

export default removeAllSlidingDoorsFromScene;
